"use strict";

window.addEventListener('DOMContentLoaded', function (event) {
  var locationMapElement = document.querySelector('.map-component.location');
  if (locationMapElement) {
    var mapElement = locationMapElement.querySelector("#map");
    if (typeof mapElement == "undefined" || !mapElement) {
      return;
    }
    var location = document.querySelector('.location');
    if (!location) {
      console.log("no location data found");
      return;
    }
    var latLong = mapElement.dataset.center;
    //flip them cause this API goes LONGITUDE THEN LATITUDE
    var mapCenter = latLong.split(",");
    var temp = mapCenter[0];
    mapCenter[0] = mapCenter[1];
    mapCenter[1] = temp;
    var geoJson = {
      type: "FeatureCollection",
      features: [{
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: mapCenter
        },
        properties: {
          name: "Location"
        }
      }]
    };
    Radar.initialize('prj_live_pk_e9bc38cc9ac871b02332c0d599d7a893c03ad94d');

    // create a map
    var map = Radar.ui.map({
      container: 'map',
      style: 'radar-light-v1',
      center: mapCenter,
      // CT
      zoom: 12
    });
    map.loadImage('/Dist/img/pin.png', function (error, image) {
      if (error) throw error;
      map.addImage('custom-marker', image);
    });
    map.on('load', function () {
      //use the custom pin

      map.addSource('locations', {
        type: 'geojson',
        data: geoJson,
        cluster: true,
        // Enable clustering
        clusterMaxZoom: 10,
        // Maximum zoom level for clustering
        clusterRadius: 50
      });
      map.addLayer({
        id: 'locationLayer-clustered',
        type: 'circle',
        source: 'locations',
        filter: ['has', 'point_count'],
        paint: {
          'circle-color': '#00A9E0',
          'circle-radius': 20
        }
      });

      //add counts 
      map.addLayer({
        id: 'locationLayer-clustercount',
        type: 'symbol',
        source: 'locations',
        filter: ['has', 'point_count'],
        layout: {
          'text-field': '{point_count_abbreviated}',
          "text-font": ["Graphik Bold"],
          'text-size': 12,
          'text-allow-overlap': true
        }
      });

      //update map with new layer 
      map.addLayer({
        id: 'locations-pins',
        source: 'locations',
        type: "symbol",
        layout: {
          'icon-image': 'custom-marker',
          'icon-overlap': 'always'
        }
      });

      /*var bounds = new maplibregl.LngLatBounds();
      //geoJson.features.forEach(function (feature, index) {
      	var coordinates = feature.geometry.coordinates;
      	bounds.extend(feature.geometry.coordinates);
      });
      		map.fitBounds([bounds._ne, bounds._sw], { padding: 50 });*/
    });
  }
  var physicianMapElement = document.querySelector('.map-component.physician');
  if (physicianMapElement) {
    var mapElement = physicianMapElement.querySelector("#map");
    var center = physicianMapElement.dataset.firstlocation;
    center = center.replace(/\[|\]/g, '').split(',');
    var geoJson = JSON.parse(physicianMapElement.dataset.geojson);
    Radar.initialize('prj_live_pk_e9bc38cc9ac871b02332c0d599d7a893c03ad94d');

    // create a map
    var _map = Radar.ui.map({
      container: 'map',
      style: 'radar-light-v1',
      center: center,
      // CT
      zoom: 13
    });
    var geojsonData = geoJson;

    //use the custom pin
    _map.loadImage('/Dist/img/pin.png', function (error, image) {
      if (error) throw error;
      _map.addImage('custom-marker', image);
    });
    _map.on('load', function () {
      // Add the GeoJSON data to the map
      _map.addSource('locationJson', {
        type: 'geojson',
        data: geojsonData,
        cluster: true,
        // Enable clustering
        clusterMaxZoom: 11,
        // Maximum zoom level for clustering
        clusterRadius: 50 // Radius for clustering in pixels
      });
      _map.addLayer({
        id: 'locationLayer-clustered',
        type: 'circle',
        source: 'locationJson',
        filter: ['has', 'point_count'],
        paint: {
          'circle-color': '#00A9E0',
          'circle-radius': 20
        }
      });

      //add counts 
      _map.addLayer({
        id: 'locationLayer-clustercount',
        type: 'symbol',
        source: 'locationJson',
        filter: ['has', 'point_count'],
        layout: {
          'text-field': '{point_count_abbreviated}',
          "text-font": ["Graphik Bold"],
          'text-size': 12,
          'text-allow-overlap': true
        }
      });
      _map.addLayer({
        id: 'locations-pins',
        source: 'locationJson',
        type: 'symbol',
        filter: ['!', ['has', 'point_count']],
        layout: {
          'icon-image': 'custom-marker',
          'icon-overlap': 'always'
        }
      });
      var bounds = new maplibregl.LngLatBounds();
      if (geojsonData.features.length > 1) {
        geojsonData.features.forEach(function (feature, index) {
          var coordinates = feature.geometry.coordinates;
          bounds.extend(feature.geometry.coordinates);
        });
        _map.fitBounds([bounds._ne, bounds._sw], {
          padding: 100
        });
      } else {
        _map.easeTo({
          center: geojsonData.features[0].geometry.coordinates,
          zoom: 12
        });
      }
      _map.on('click', 'locations-pins', function (e) {
        var coordinates = e.features[0].geometry.coordinates.slice();
        var description = e.features[0].properties.description;

        // Ensure that if the map is zoomed out such that multiple
        // copies of the feature are visible, the popup appears
        // over the copy being pointed to.
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }
        new maplibregl.Popup().setLngLat(coordinates).setHTML(description).addTo(_map);
      });
      _map.on('click', 'locations-clustered', function (e) {
        var features = _map.queryRenderedFeatures(e.point, {
          layers: ['locations-clustered']
        });
        var clusterId = features[0].properties.cluster_id;
        _map.getSource('locationJson').getClusterExpansionZoom(clusterId, function (err, zoom) {
          if (err) return;
          _map.easeTo({
            center: features[0].geometry.coordinates,
            zoom: 10
          });
        });
      });
    });
  }
});
function RadarGeocodeForward(value) {
  var endpoint = 'https://api.radar.io/v1/geocode/forward?query=';
  if (value) {
    endpoint = endpoint + value;
    var xhr = new XMLHttpRequest();
    // Open the request synchronously
    xhr.open('GET', endpoint, false);

    // Set the "Authorization" header
    xhr.setRequestHeader("Authorization", "prj_live_pk_e9bc38cc9ac871b02332c0d599d7a893c03ad94d");

    // Send the request
    xhr.send();

    // Check the response status
    if (xhr.status === 200) {
      // Parse and handle the response
      var responseData = JSON.parse(xhr.responseText);
      return responseData;
    } else {
      console.error('Network response was not ok');
    }
  } else {
    console.log("RadarGeocodeForward: you need to pass a value");
  }
}
window.initLocationMap = function () {
  var mapElement = document.getElementById("map");
  if (typeof mapElement == "undefined" || !mapElement) {
    return;
  }
  var location = document.querySelector('.location');
  if (!location) {
    return;
  }
  var locationObj = new Location(location);
  var startingAddress = document.getElementById("starting-address");
  var getDirections = document.getElementById("get-directions");
  if (startingAddress && getDirections) {
    getDirections.addEventListener("click", function (e) {
      e.preventDefault();
      var url = "https://www.google.com/maps/dir/";
      var toAddress = locationObj.address;
      if (startingAddress.value != "") {
        url += startingAddress.value;
      }
      url += "/" + toAddress;
      window.open(url, '_blank');
    });
  }
  var googleHelpers = new GoogleHelpers(mapElement);
  AddLocationToMap(locationObj, googleHelpers);
};
window.initLocationMapByType = function () {
  var mapElement = document.getElementById("map");
  if (typeof mapElement == "undefined" || !mapElement) {
    return;
  }
  var locations = document.querySelectorAll('.location');
  if (!locations) {
    return;
  }
  var googleHelpers = new GoogleHelpers(mapElement);
  locations.forEach(function (l) {
    AddLocationToMap(new Location(l), googleHelpers);
  });
};
window.initPhysicianMap = function () {
  var mapElement = document.getElementById("map");
  if (typeof mapElement == "undefined" || !mapElement) {
    return;
  }
  var locations = document.querySelectorAll('.facility-location');
  if (!locations) {
    return;
  }
  var googleHelpers = new GoogleHelpers(mapElement);
  locations.forEach(function (l) {
    AddLocationToMap(new Location(l), googleHelpers);
  });
};
function AddLocationToMap(location, googleHelpers) {
  if (location.hasCoords) {
    AddMarker(location, googleHelpers);
  } else {
    googleHelpers.geocoder.geocode({
      'address': location.address
    }, function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        location.coords = results[0].geometry.location;
        AddMarker(location, googleHelpers);
      }
    });
  }
}
function AddMarker(location, googleHelpers) {
  var rotateFactor = 36; // 360/10, 10 is max # of markers with same coords
  var radius = 0.00006;

  // Spread out locations with same lat/long
  for (var i = 0; i < googleHelpers.markertracker.length; i++) {
    if (googleHelpers.markertracker[i].coords.lat == location.coords.lat && googleHelpers.markertracker[i].coords.lng == location.coords.lng) {
      location.coords.lat = location.coords.lat + radius * Math.cos(googleHelpers.markertracker[i].count * rotateFactor);
      location.coords.lng = location.coords.lng + radius * Math.sin(googleHelpers.markertracker[i].count * rotateFactor);
      googleHelpers.markertracker[i].count++;
      break;
    }
  }
  googleHelpers.markertracker.push({
    coords: location.coords,
    count: 1
  });
  var marker = new google.maps.Marker({
    position: location.coords,
    map: googleHelpers.map,
    title: location.title,
    icon: "/Dist/img/pin.svg"
  });

  // Create infowindow popup
  var content = GenerateInfoContent(location);
  var infowindow = new google.maps.InfoWindow({
    content: content
  });
  marker.addListener('click', function () {
    if (googleHelpers.openInfoWindow) {
      googleHelpers.openInfoWindow.close();
    }
    googleHelpers.openInfoWindow = infowindow;
    infowindow.open(googleHelpers.map, marker);
  });
  googleHelpers.markers.push(marker);
  googleHelpers.markerClusterer.addMarker(marker);
  var loc = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
  googleHelpers.bounds.extend(loc);

  // If only one location, center and zoom on that.
  if (googleHelpers.markers.length == 1) {
    googleHelpers.map.setZoom(15);
    googleHelpers.map.setCenter(location.coords);
    // Else, adjust center/zoom for all locations
  } else {
    googleHelpers.map.fitBounds(googleHelpers.bounds); // auto-zoom
    googleHelpers.map.panToBounds(googleHelpers.bounds); // auto-center
  }
}
function Location(location) {
  var geoElement = location.querySelector(".location-geo");
  if (typeof geoElement !== "undefined" && geoElement && geoElement.value !== "") {
    var geo = geoElement.value.replace(/\s/g, '');
    var coords = geo.split(',');
    if (coords.length == 2) {
      var lati = parseFloat(coords[0]);
      var longi = parseFloat(coords[1]);
      if (!isNaN(lati) && !isNaN(longi)) {
        this.coords = {
          lat: lati,
          lng: longi
        };
        this.hasCoords = true;
      }
    }
  }
  var titleElement = location.querySelector('.location-title');
  if (typeof titleElement !== "undefined" && titleElement && titleElement.value !== "") {
    this.title = titleElement.value;
  }
  var addressElement = location.querySelector(".location-address");
  if (typeof addressElement !== "undefined" && addressElement && addressElement.value !== "") {
    this.address = addressElement.value;
  }
  var phoneElement = location.querySelector(".location-phone");
  if (typeof phoneElement !== "undefined" && phoneElement && phoneElement.value !== "") {
    this.phone = phoneElement.value;
  }
  var faxElement = location.querySelector(".location-fax");
  if (typeof faxElement !== "undefined" && faxElement && faxElement.value !== "") {
    this.fax = faxElement.value;
  }
  var hoursElement = location.querySelector(".location-hours");
  if (typeof hoursElement !== "undefined" && hoursElement && hoursElement.value !== "") {
    this.hours = hoursElement.value;
  }
  var directionsElement = location.querySelector(".location-directionslink");
  if (typeof directionsElement !== "undefined" && directionsElement && directionsElement.value !== "") {
    this.directionslink = directionsElement.value;
  }
  var urlElement = location.querySelector(".location-url");
  if (typeof urlElement !== "undefined" && urlElement && urlElement.value !== "") {
    this.url = urlElement.value;
  }
}
function GoogleHelpers(mapElement) {
  this.map = new google.maps.Map(mapElement);
  this.geocoder = new google.maps.Geocoder();
  this.bounds = new google.maps.LatLngBounds();
  this.markers = [];
  this.markertracker = [];
  this.openInfoWindow = null;
  this.markerClusterer = new MarkerClusterer(this.map, this.markers, {
    maxZoom: 20,
    styles: [MarkerClusterer.withDefaultStyle({
      width: 53,
      height: 52,
      url: "/Dist/img/cluster1.png",
      textColor: "#ffffff",
      textSize: 12
    }), MarkerClusterer.withDefaultStyle({
      width: 56,
      height: 55,
      url: "/Dist/img/cluster2.png",
      textColor: "#ffffff",
      textSize: 12
    }), MarkerClusterer.withDefaultStyle({
      width: 66,
      height: 65,
      url: "/Dist/img/cluster3.png",
      textColor: "#ffffff",
      textSize: 12
    })]
  });
}
function GenerateInfoContent(location) {
  var title = location.title;
  var address = location.address;
  var phone = location.phone;
  var fax = location.fax;
  var hours = location.hours;
  var directionsLink = location.directionslink;
  var url = location.url;
  var content = '<div class="map-overlay">';
  if (title && title != '') {
    if (url && url != '') {
      content += '<p class="location"><a href="' + url + '">' + title + '</a></p>';
    } else {
      content += '<p class="location">' + title + '</p>';
    }
  }
  content += '<div class="address">';
  if (address && address != '') {
    content += '<div><p>' + address + '</p></div>';
  }
  content += '<div>';
  if (phone && phone != '') {
    content += '<span class="label">Main</span> ' + phone;
  }
  if (fax && fax != '') {
    content += '<br/><span class="label">Fax</span> ' + fax;
  }
  content += '</div>';
  content += '</div>';
  if (directionsLink && directionsLink != '') {
    content += '<a href="' + directionsLink + '" class="btn light-blue-filled">Get Directions</a>';
  }
  if (hours && hours != '') {
    content += hours;
  }
  content += '</div>';
  return content;
}